// Wishlist Service Utility with Local Storage persistence & event dispatch

const WISHLIST_KEY = "gootocart_wishlist";

export const getWishlist = () => {
  try {
    const data = localStorage.getItem(WISHLIST_KEY);
    return data ? JSON.parse(data) : [];
  } catch (e) {
    return [];
  }
};

export const getWishlistCount = () => {
  return getWishlist().length;
};

export const isInWishlist = (productId) => {
  if (!productId) return false;
  const list = getWishlist();
  return list.some((item) => String(item.id) === String(productId));
};

export const addToWishlist = (product) => {
  if (!product || !product.id) return false;
  const list = getWishlist();
  if (!isInWishlist(product.id)) {
    const updated = [
      {
        id: product.id,
        name: product.name,
        slug: product.slug,
        image: product.product_image?.[0]?.image || product.image,
        categorySlug: product.category?.slug,
        categoryName: product.category?.name,
        price: product.productprices?.seeling_price || product.sellingPrice || 0,
        addedAt: new Date().toISOString(),
      },
      ...list,
    ];
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(updated));
    window.dispatchEvent(new Event("wishlistUpdated"));
    return true;
  }
  return false;
};

export const retainVisibleWishlist = (visibleIds) => {
  const allowed = new Set((visibleIds || []).map((id) => String(id)));
  const list = getWishlist();
  const next = list.filter((item) => allowed.has(String(item.id)));
  if (next.length !== list.length) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(next));
    window.dispatchEvent(new Event("wishlistUpdated"));
  }
  return next;
};

export const removeFromWishlist = (productId) => {
  if (!productId) return false;
  const list = getWishlist();
  const updated = list.filter((item) => String(item.id) !== String(productId));
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(updated));
  window.dispatchEvent(new Event("wishlistUpdated"));
  return true;
};

export const toggleWishlist = (product) => {
  if (!product || !product.id) return false;
  if (isInWishlist(product.id)) {
    removeFromWishlist(product.id);
    return false;
  } else {
    addToWishlist(product);
    return true;
  }
};
